import React, { useEffect, useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";

import apiCall from "../../../../../components/Api";
import BackBtn from "../../../../../components/Common/backBtn";
import Breadcrumbs from "../../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import InputRadioField from "../../../../../components/Common/inputRadioField";
import InputTextField from "../../../../../components/Common/inputTextField";
import SucessModal from "../../../../../components/Modal/SucessModal";

const DoctorClinicSpecialityForm = ({ edit = false, view = false }) => {
  const { id } = useParams();

  const {
    register,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [success, setSuccess] = useState(false);

  const getMenuData = async () => {
    const result = await apiCall(`clinic-speciality/get/${id}`, "GET");
    if (result?.data?._id) {
      setValue("active", result.data.active);
      setValue("clinic_speciality", result.data.clinic_speciality);
    }
  };

  useEffect(() => {
    (view || edit) && getMenuData();
  }, []);

  const onSubmit = async (fields) => {
    if (edit) {
      const result = await apiCall(
        `clinic-speciality/update/${id}`,
        "PATCH",
        fields,
      );
      if (result.data?._id) {
        setSuccess(true);
      }
    } else {
      const result = await apiCall(`clinic-speciality/create`, "POST", fields);
      if (result.data?._id) {
        setSuccess(true);
      }
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Doctor",
        link: "/add-new-doctors",
      },
      {
        text: "Common Heads",
        link: "/doctors-language",
      },
      {
        text: "Clinic Speciality",
        link: "/doctors-clinic-speciality",
      },
      {
        text: edit
          ? "Edit Clinic Speciality"
          : view
            ? "View Speciality"
            : "Add New Clinic Speciality",
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="w-100 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      <BackBtn navigatePath="/doctors-clinic-speciality" />
      <div className="healtharticle mt-5">
        {/* <div className="pt-3 ms-3">
          <Breadcrumbs
            breadcrumbText="Doctor"
            breadcrumbLink="/"
            nestedText="Common Heads"
            nestedLink=""
            nestedText2="Clinic Speciality"
            nestedLink2=""
            nestedText3={edit ? "Edit Clinic Speciality" : "Add New Clinic Speciality"}
            nestedLink3=""
          />
        </div> */}
        <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
          <div className="row car-dep-form">
            <div className="col-5">
              <InputTextField
                register={register}
                errors={errors}
                labelName="Clinic Speciality"
                errorText="Please enter the clinic speciality"
                name="clinic_speciality"
                placeholder="Type here..."
                view={view}
              />
            </div>
            <div className="col-3">
              <InputRadioField
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                disabled={view}
              />
            </div>
          </div>

          {!view && (
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          )}
        </form>
      </div>
      {success && (
        <SucessModal
          page={"/doctors-clinic-speciality"}
          name="new clinic speciality"
          post={edit ? "updated" : "added"}
        />
      )}
    </>
  );
};

export default DoctorClinicSpecialityForm;
